/**
 * Constants related to tooltips used in thios project
 *
 *
 */

export const SWITCH_DIST_GRAPH =
	'Displays the count of switches by model and firmware version within the site';
export const DOWN_UP_LINK_GRAPH =
	'Downlink and uplink data rates over time for the switches in the site';
export const SWITCH_NAME =
	'Enter a unique name for the switch to identify it within the network';
export const SERIAL_NUMBER =
	'Required. Must be a valid alphanumeric string without spaces, typically 13 characters long';
export const SWITCH_DISCRIPTION =
	'Provide a brief description of the switch (optional)';
export const SOFTWARE_CONFIGURATION =
	'Select the software version to which the switch should be upgraded';
export const SWITCH_CONFIGURATION =
	'Select a configuration file from the dropdown or upload a new configuration file';
export const PORT_PREVIEW =
	'Visual representation of switch ports, showing status and connection speed for each port';
export const OPERATION_STATUS =
	'Displays the current operational settings of the switch';
export const LLDP_LOCAL_DEVICES =
	'Displays the details of local device advertised via LLDP';
export const POE_ULTLISATION =
	'Shows the Power over Ethernet (PoE) usage across different ports';
export const CONNECTIVITY =
	'Illustrates the connectivity status and network details of the switch';
export const TRAFFIC_PERFORMANCE =
	'Displays the downlink and uplink data rates over time for the switch';
export const CPU_MEMORY_ULTLISATION =
	'Tracks the CPU and memory usage of the switch over time';

export const SWITCH_MEMORY_UTILIZATION_TT = 'Tracks the memory usage of the switch over time';
export const SWITCH_CPU_LOAD_TT = 'Tracks the CPU Load of the switch over time';
export const SWITCH_TEMPERATURE_TT = 'Tracks the temperature for switch over time';

export const USERNAME = 'Enter unique username for accessing io Canvas.';
export const PASSWORD = 'Enter password to sign in to io Canvas.';
export const TENANT_NAME =
	"Enter the name of the io Canvas tenant's organization or company.";
export const SIGNUP_USERNAME =
	'Enter unique username to create io Canvas account.';
export const SIGNUP_PASSWORD = 'Create secure password for io Canvas account.';
export const SIGNUP_CONFIRM_PASSWORD = 'Re-enter password to confirm.';
export const SIGNUP_EMAIL =
	'Enter e-mail address to link with io Canvas account.';
export const SIGNUP_PHONE_NUMBER =
	'Enter phone number to receive OTPs and account notifications.';
export const SIGNUP_REGION = 'Select region to customize io Canvas.';
export const TIMEZONE = 'Select timezone.';
export const ADDRESS = 'Enter full address.';
export const RESET_USERNAME =
	'Enter username or e-mail address to reset io Canvas password.';
export const OTP =
	'Enter the OTP sent to the registered e-mail or phone number.';
export const RESET_PASSWORD = 'Create new password for io Canvas account.';
export const RESET_CONFIRM_PASSWORD = 'Re-enter new password to confirm.';
export const GROUP_NAME = 'Enter the name of the site.';
export const LOCATION =
	"Enter the name for this site's location (e.g., city, floor, or region).";
export const SAPID = 'Enter a unique numerical identifier for this site';
export const DESCRIPTION = 'Provide a brief description of the site.';
export const NTP_SERVER1 = 'Enter the primary NTP server address.';
export const NTP_SERVER2 = 'Enter the secondary NTP server address (optional) ';
export const UPLOAD_LICENCE_BUTTON =
	'Click to upload the license file for io Canvas or drag/drop license file.';
export const ACTIVATE_LICENSE = 'Click to activate io Canvas license.';
export const SSIDTT = 'WiFi Network / Service Set Identifier';

// Global profiles - vlan pool
export const VLAN_PROFILE_NAME =
	'VLAN Pool Profile name should be minimum 4 and maximum 32 characters long. Spaces are not allowed in the beginning and at the end of the Profile Name';
export const VLAN_IDS =
	'VLAN should be in the range 2-4094. VLAN can be provided as numbers seperated by comma eg. 2,10.';
export const VLAN_DESCRIPTION = 'Enter a description for the VLAN pool';

// Global profiles - SSID Schedule
export const SSID_PROFILE_NAME = 'Profile name should be 2-32 characters long';

// Global profiles - EOGRE
export const EOGRE_PROFILE_NAME =
	'EoGRE Profile name should be 2-32 characters long';
export const EOGRE_ICMP_INTERVAL =
	'Enter the ICMP interval in seconds. ICMP interval should be between 5 seconds to 300 seconds';
export const EOGRE_RETRYCOUNT =
	'Enter the retry count. Retry count should be between 1-10';
export const EOGRE_PRIMARY_IPV4_ADDRESS = 'Enter the primary IPv4 address';
export const EOGRE_PRIMARY_IPV6_ADDRESS = 'Enter the primary IPv6 address';
export const EOGRE_SECONDARY_IPV4_ADDRESS = 'Enter the secondary IPv4 address';
export const EOGRE_SECONDARY_IPV6_ADDRESS = 'Enter the secondary IPv6 address';
export const EOGRE_DEAD_INTERVAL =
	'Dead Interval should be between 5 minutes to 1000 minutes';

// Global profiles - Nat config
export const NAT_CONFIG_PROFILE_NAME =
	'NAT Profile name should be 2-32 characters long';
export const NAT_CONFIG_IP =
	'Enter a valid NAT IP. Multicast, loopback (127.x.x.x, 224.x.x.x), and reserved IPs (255.255.255.255, 0.0.0.0) are not allowed.';
export const NAT_CONFIG_NETMASK_IP =
	'Enter a valid NetMask IP. Multicast, loopback (127.x.x.x, 224.x.x.x), and reserved IPs (255.255.255.255, 0.0.0.0) are not allowed.';
export const NAT_CONFIG_START_IP =
	'Enter the starting IP. Multicast, loopback (127.x.x.x, 224.x.x.x), and reserved IPs (255.255.255.255, 0.0.0.0) are not allowed.';
export const NAT_CONFIG_END_IP =
	'Enter the ending NAT IP. Multicast, loopback (127.x.x.x, 224.x.x.x), and reserved IPs (255.255.255.255, 0.0.0.0) are invalid';
export const NAT_CONFIG_SECONDARY_LEASE_TIME =
	'Select the lease time for the IP allocation. The default lease time is 12 hours and minimum it is 2 minutes';

// Global profiles - Multipsk
export const MULTIPSK_PROFILE_NAME =
	'Enter the profile name for the Multi PSK. Range should between 2-32 characters';
export const MULTIPSK_LENGTH =
	'Enter the PSK length between 8 and 63 characters';
export const MULTIPSK = 'Enter a alpha numeric password range is min 8 and max 63 characters long.'
export const MULTIPSK_NUMBER =
	'Enter the number of PSKs required and should be in the range of 1-500';
export const MULTIPSK_TYPE =
	'Select the type of PSK. ( Secure PSK : Includes all the possible ASCII characters. Mobile Freindly : Includes numbers , lower and upper cases)';
export const MULTIPSK_DEVICE_TYPE = 'Select the device type of PSK';
export const MULTIPSK_METHOD = 'Select the method for the PSK';
export const MULTIPSK_VLAN =
	'VLAN can be minimun 1 and maximum 4094. VLAN can be provided as a range eg. 1-5 or random numbers separated by comma eg. 2, 10.';
export const MULTIPSK_EXPIRY =
	'Select the expiration date for the PSK.     Note : PSK expiry is not applicable for TIP Devices';
export const MULTIPSK_LIMIT =
	'Enter the limit for the number of PSKs. Range should be between 1 to 4';

export const PORT_SPEED_DUPLEX =
	'Select the speed and duplex mode for the port';
export const PORT_LABEL =
	'Enter a custom label for the port for easier identification';
export const POE_BUDGETING = 'Select the PoE budgeting mode for the port';
export const POE_PRIORITY = 'Set the priority level for PoE power allocation';
export const POE_USER_POWERLIMIT =
	'Enter the maximum power limit for this port in watts';
export const PVID = 'Select the Port VLAN Identifier (PVID) for the port';
export const ENABLE_VOICE_VLAN = 'Enable or disable Voice VLAN for the port';
export const VLAN_TRUNKING =
	'Enable or disable VLAN trunking on the port to allow multiple VLANs';
export const FORWARD_PORTS =
	'Specify the ports to which this port can forward traffic when isolation is enabled';
export const RECEIVE_RATE_LIMITS =
	'Set the maximum receive rate for the port in Mbps';
export const TRANSMIT_RATE_LIMITS =
	'Set the maximum transmit rate for the port in Mbps';
export const FLOW_CONTROL = 'Enable or disable flow control on the port';
export const COS_VALUE =
	'Set the Class of Service (CoS) value for traffic prioritization';
export const TRUST_COS =
	'Enable or disable trusting CoS markings on incoming packets';

// Captive Portal and Plans

export const PLAN_NAME =
	'Plan name should accept minimum 3 and maximum 32 characters without any spaces.';
export const VALIDITY_TIME =
	'Set how long a session should remain active in a plan';
export const SESSION_TIMEOUT =
	'Set how long a session should remain active in a plan';
export const SESSION_TIMEOUT_SECONDS =
	'Duration after which user session will expire.';
export const PLAN_DESCRIPTION = 'Provide a description for the plan';
export const RATE_LIMIT = 'Rate limit should be in MB/s and is optional';
export const QUOTA_TYPE = 'Select the quota type for the plan';
export const TOTAL_DATA = 'Total Quota should be between 1 MB to 1024 MB';
export const UPLOAD_DATA = 'Upload quota should be between 1MB to 1024MB';
export const DOWNLOAD_DATA = 'Download quota should be between 1MB to 1024MB';
export const CAPTIVE_PORTAL_NAME =
	'Special characters and spaces are not allowed.';
export const UAM_PORT =
	'UAM Port should be minimum 1024 and maximum 65535';
export const IDLE_TIMEOUT =
	'Idle Timeout should be between 60 seconds to 15780096 seconds';
export const SPLASH_PAGE_URL =
	'Splash URL should be like https://example.com/captive/ or IP Address(e.g., https://1.1.1.1/).';
export const CP_SELECT_PLAN = 'Choose the plan name for the captive portal.';
export const HOMEPAGE_URL = 'Enter the URL users will be redirected to after successful login.';
export const COMPANY_NAME_ON_VOUCHER =
	'Enter the company name to be displayed on the voucher';
export const COMPANY_LOGO =
	'Click to upload the company logo to be displayed on the vouchers, Max size is 5MB.';
export const ENCRYPTION_CHECK = 'Enable encryption for the portal';
export const ENCRYPTION_PASSKEY = 'Enter a passkey for encryption';
export const SECURE_LOGON_CHECK =
	'Enable HTTPS-based secure login for portal access.';
export const WALLED_GARDEN_CHECK =
	'Allow users access to specific URLs/IPs before authentication.';
export const AUTHENTICATION_TYPE = 'Select the type of authentication method';
export const WALLED_GARDEN_URL =
	'Enter comma separated values';
export const TERMS_CONDITION_CHECK =
	'Enable terms and conditions for the splash page';
export const TERMS_CONDITION_TYPE =
	'Select how terms and conditions should be handled';
export const TERMS_CONDITION = 'Enter the terms and conditions';
export const TERMS_CONDITION_URL = 'Enter the URL for the terms and conditions';
export const AAA_PROFILE_SELECT =
	'Select an AAA profile from the list or enter the IP address manually';
export const IP_ADDRESS_CP =
	'Enter the IP address of the server for AAA profile.';
export const ENABLE_EMAIL_APPROVAL =
	'Enable approval by email for restricted access';
export const VOUCHER_COUNT =
	'Count should be between 1 - 1000';
// Global Profiles - AAA Server

export const AAA_SERVER_NAME =
	'Enter the name of the AAA Server. Only alphanumeric characters and the special character _ is allowed.';
export const IO_CANVAS_PROXY_PORT =
	'Enable to configure cNMS Proxy Ports for the Captive Portal profile';
export const SERVER_IO_TYPE_IPV4 = 'Select if the server uses IPv4 addresses';
export const SERVER_IO_TYPE_IPV6 = 'Select if the server uses IPv6 addresses';
export const SERVER_IO_TYPE_IPV4_IPV6 = 'IPv4: Select if the server uses IPv4 addresses. IPv6: Select if the server uses IPv6 addresses.';
export const AUTH_SERVER_IP =
	'Enter a valid IP4/IPv6 address of the primary external Auth server';
export const ACCOUNTING_SERVER_IP =
	'Enter the IP address of the accounting server which is used to track user activities';
export const AUTH_SERVER_PORT =
	'Enter the port number of the external AAA server. Range of the port number(1-65535)';
export const AUTH_PASSPHRASE =
	'Enter the passphrase for the authentication server and the minium length required is 4 and max 64 characters long';
export const ACCOUNTING_PASSPHRASE =
	'The passphrase for the accounting server should contain 4 - 64 characters (including white spaces)';
export const ACCOUNTING_SERVER_PORT =
	'Enter the port number for the accounting server. Range of the port number(1-65535)';

// Global Profiles - Mac ACL

export const ACL_PROFILE_NAME = 'Enter the acl profile name';
export const MAC_ADDRESS = 'Enter the MAC address';
export const TOTOA_VALID_MAC_COUNT = 'Enter the total valid mac count';

// Group Dashboard - ADD SSID Modal

export const SSID_NAME_TT =
	'Enter the name of the SSID for the wireless network';
export const SECURITY_TYPE_TT = 'Select the security type for this SSID';
export const SSID_PSK_KEY_TT = 'Pre-shared Key should be min 8 and max 63 characters long and should not have double quote (") and single backslash (\\)';
export const SSID_TEMPLATE_SELECT_TT =
	'Optionally select a SSID template to pre-fill the form. You can customize any field, if required.';
export const AAA_SERVER_LIST_TT =
	'Select the AAA (Authentication, Authorization, and Accounting) server for this SSID';
export const RADIO_TYPE_TT =
	'2.4 GHz: Select to enable the SSID on the 2.4 GHz band. 5 GHz: Select to enable the SSID on the 5 GHz band.';
export const ACCESS_MODE_TT =
	"Bridge: Forwards client traffic directly to the local network. NAT: Translates client IPs to the AP’s IP before forwarding traffic.";
export const EOGRE_TT =
	'Select the Ethernet Over GRE (EoGRE) profile to use for this SSID';
export const VLAN_TT = 'Enable VLAN tagging for client traffic on this SSID.';
export const VLAN_ID_TT = 'Enter the VLAN ID to associate with this SSID.';
export const VLAN_POOL_TT =
	'Distribute clients across VLANs from a predefined pool';
export const VLAN_POOL_PROFILE_TT =
	'Select the VLAN Pool Profile to use for this SSID';
export const L2_ROAMING_TT =
	'Enable Layer 2 Roaming for seamless mobility of clients';
export const MOBILITY_DOMAIN_TT =
	'Enter the Mobility Domain identifier for Layer 2 Roaming';
export const NAS_ID_CB_TT =
	'Used to uniquely identify an AP during RADIUS authentication, especially in large networks or roaming scenarios.';
export const NAS_ID_TT =
	'NAS ID should contain an alphanumeric character with a maximum limit of 32';
export const PMF_TT =
	'Enable Protected Management Frames (PMF) to secure management traffic. Required for Wi-Fi 6 and recommended for Wi-Fi 5.';
export const CLIENT_ISOLATION_TT =
	'Prevent communication between clients connected to the same SSID for enhanced security.';
export const L2_ISOLATION =
    'L2 isolation prevents clients connected to the same SSID from communicating with each other via MAC layer protocols.'
export const MAC_ACL_TT =
	'Enable MAC-based access control to allow or block clients using their MAC addresses.';
export const MAC_ACL_PROFILE_TT =
	'Select the MAC ACL profile to apply access control based on MAC addresses';
export const MAC_ACL_ALLOW_DENY_TT =
	'Choose whether to allow or deny clients based on the selected MAC ACL profile';
export const MAX_CLIENT_ALLOWED_TT =
	'Enable to set a limit on the maximum number of clients that can connect to this SSID.';
export const MAX_CLIENT_LIMIT_TT =
	'Enter the maximum number of clients allowed to connect to this SSID.';
export const BAND_STEERING_TT =
	'Enable Band Steering to encourage dual-band clients to connect to the 5 GHz band.';
export const DOWN_STEERING_THRESHOLD_TT =
	'Set the signal strength threshold below which clients will be steered to the 2.4 GHz band.';
export const UP_STEERING_THRESHOLD_TT =
	'Set the signal strength threshold above which clients will be steered to the 5 GHz band.';
export const HIDDEN_SSID_TT =
	'Enable Hidden SSID to prevent the SSID from being broadcast publicly';
export const MULTI_PSK_PROFILE_TT =
	'Select the Multi PSK profile to apply to this SSID.';
export const DHCP_OPTION_82_TT =
	'Append relay agent information (e.g., circuit ID, remote ID) to DHCP requests';
export const CIRCUIT_ID_TT =
	'Select AP identifiers to insert as Circuit ID in DHCP packet.';
export const CUSTOM_VALUE_CIRCUIT_TT = 
	'Enter a manual Circuit ID for custom DHCP tagging.'
export const FORMAT_CIRCUIT_TT =
	'Select how Circuit ID is structured.'
export const DELIMITER_CIRCUIT_TT =
	'Select a separator between values in Circuit ID'
export const REMOTE_ID_TT =
	'Select what to include as the Remote ID field in DHCP Option 82';
export const CUSTOM_VALUE_REMOTE_TT = 
	'Enter a manual Remote ID for custom DHCP tagging.'
export const FORMAT_REMOTE_TT =
	'Select how Remote ID is structured.'
export const DELIMITER_REMOTE_TT =
	'Select a separator between values in Remote ID'
export const MAC_CASE_TT = 
	'Select letter casing for MAC addresses'
export const MAC_DELIMITER_TT = 
	'Select symbol used to separate bytes in MAC address'
export const DHCP_PACKET_TT =
	'Select which DHCP packet type carries Option 82.';
export const DHCP_OPTION_18_TT =
	'Append interface or circuit identifiers in DHCP requests';
export const IGMP_SNOOPING__TT =
	'Enable this to forward multicast traffic only to clients that have joined the multicast group.'
export const WMM_TT =
	'Enable WMM to prioritize multimedia traffic, such as video and voice, over other types of traffic.';
export const RATE_LIMIT_TT =
	'Enable to enforce upload and download speed limits for client traffic.';
export const PER_VAP_PER_CLIENT_TT =
	'Select whether bandwidth limits apply per SSID (VAP) or individually per connected client.';
export const UPLOAD_LIMIT_TT = 'Enter the maximum upload speed limit in Mbps.';
export const DOWNLOAD_LIMIT_TT =
	'Enter the maximum download speed limit in Mbps.';
export const ATF_TT =
	'Enable Airtime Fairness to balance radio time usage across connected clients.';
export const ATF_PROFILE_TT = 'Select the ATF profile to apply.';
export const IO_PASS_TT = 'Enable io Pass';
export const IO_PASS_PROFILE_TT = 'Select the io Pass profile ';
export const HOTSPOT_ENABLE_TT = 'Enable Hotspot 2.0 to support ';
export const HOTSPOT_INTERNET_TT =
	'Indicate if the hotspot provides internet access';
export const HOTSPOT_DGAF_TT =
	'Enable DGAF to disable downlink global ARP filtering in Hotspot 2.0';
export const ACCESS_NETWORK_TYPE_TT =
	'Select the type of access network provided';
export const VENUE_INFO_TT =
	'Select the venue type that best describes the hotspot location (e.g., coffee shop, airport)';
export const GPP_INFO_TT =
	'Enter the 3GPP Cellular Network Information for integration with cellular networks';
export const NAI_REALM_INFO_TT =
	'Enter the NAI Realm information to specify domains for client authentication';
export const ROAMING_TT =
	'Enter the Roaming Consortium OI for network identification and roaming';
export const HESSID_TT =
	'Enter the Homogeneous ESSID (HESSID) for the Hotspot 2.0 network';
export const DOMAIN_NAME_TT =
	'Enter the domain name associated with the Hotspot 2.0 network';
export const QOS_CB_TT =
	'Enable WMM to prioritize upstream/downstream traffic for better QoS between AP and Wi-Fi clients.';
export const QOS_LOAD_TT =	'Enable to see the BSS load related information in beacons';
export const CAPTIVE_PORTAL_TT =
	'Select external if a captive portal is outside WLC and internal if captive portal is inside WLC';
export const CAPTIVE_PROFILE_TT =
	'Select a captive profile from the types given';
export const ENABLE_RRM_TT = 'Enable Radio Resource Management (RRM) to help clients discover neighboring APs for efficient roaming.';
export const ENABLE_WNM_TT = 'Enable BSS Transition Management to assist clients in selecting better APs for optimized roaming.';
export const CLIENT_INACTIVE_TIME_TT =
	'Set the time (in seconds) after which inactive clients are disconnected.';
export const URL_FILTERING_CB_TT =
	'Enable to control client access to specific IP addresses or web domains.';
export const URL_FILTERING_BLACK_WHITE_TT =
	'Blacklist: Block the given URLs/categories,Whitelist: Allow only given URLs/categories';
export const URL_LIST_TT =
	'URLs/Categories\n' +
	'(video_c, music_c, news_c, social_c,\n' +
	'games_c, call_c, shopping_c)\n' +
	'to be Blacklisted/Whitelisted\n' +
	'(comma separated without whitespaces)';
export const RADIUS_MAC_ACL_TT =
	'Enable Radius MAC ACL to select RADIUS MAC ACL Server';
export const GLOBAL_SSID_CB = 'Enable to broadcast this SSID across all sites globally.';
export const OPEN_ST_TT = 'No encryption or authentication; not recommended.';
export const OWE_TRANSITION_ST_TT =
	'Improved privacy for open networks with backward compatibility.';
export const WPA3_PERSONAL_ST_TT =
	'Most secure option for personal networks using modern encryption.';
export const WPA3_PERSONAL_MIXED_ST_TT =
	'Supports WPA2 and WPA3 devices for gradual migration.';
export const WPA3_ENTERPRISE_ST_TT =
	'Enterprise-grade security with user authentication via RADIUS.';
export const WPA3_ENTERPRISE_TRANSITION_ST_TT =
	'Transition mode for networks migrating from WPA2 to WPA3 Enterprise.';
export const WPA3_SUITE_B_ST_TT =
	'High-security standard for sensitive environments (e.g., government use).';
export const WPA2_PSK_ST_TT =
	'Widely supported secure option for personal networks with a shared password.';
export const WPA2_PSK_MIXED_ST_TT =
	'Supports WPA and WPA2 devices for compatibility.';
export const WPA2_EAP_ST_TT =
	'Enterprise security with authentication via RADIUS.';
export const DYNAMIC_MPSK_ST_TT =
	'Unique pre-shared key for each device for added security.';
export const STATIC_MPSK_ST_TT =
	'Predefined multiple keys for site-specific device management.';
export const WPA_PSK_ST_TT =
	'Legacy security option using WPA with a pre-shared key. Less secure than WPA2 or WPA3.';
export const MIN_BASIC_RATE_TT = 'Set the minimum required data rate for clients connecting on each SSID and band.';
export const MIN_24_GHZ_RATE_TT = 'Select one of the following minimum basic rate for 2.4GHz.'
export const MIN_5GHZ_RATE_TT = 'Select one of the following minimum basic rate for 5GHz.';
export const B_TX_RATES_TT = 'Disable legacy 802.11b rates (1, 2, 5.5, 11 Mbps) to improve performance on the 2.4 GHz band.';
export const FieldDelimiterTT = 'Select the delimiter to separate the chosen identifiers';

// Graph Tooltip - Home dashboard

export const ClientsGraphHDTT =
	'Shows the number of connected clients over time, split by frequency bands (2.4 GHz and 5 GHz)';
export const DataBandwidthRangeGraphHDTT =
	'Shows the distribution of clients across different bandwidth ranges, categorized by Mbps, indicating how many clients fall into each bandwidth range.';
export const DataThroughputGraphHDTT =
	'Displays the distribution of clients across different bandwidth ranges. The x-axis categorizes bandwidth in Mbps, and the y-axis shows the number of clients in each range.';
export const IssuesGraphHDTT =
	'Shows the number and type of network issues categorized into Connectivity, Steering, and Roaming. The bar is divided into segments representing each issue type, with the length indicating the count.';
export const TopPerformingGroupsGraphHDTT =
	'Displays the best performing sites, ranked on Quality of Experience (QoE), along with the number of connected clients and online APs.';
export const TopImpactedGroupsGraphHDTT =
	'Displays the worst performing sites, ranked on Quality of Experience (QoE), along with the number of connected clients and online APs.';
export const ActiveQOEGraphHDTT =
	'Tracks the number of active Access Points (APs) and the Quality of Experience (QoE) percentage over time, along with the number of connected clients.';
export const APModelFirmwareDistributionGraphHDTT =
	'Shows the distribution of Access Points (APs) by model and firmware version, with each bar indicating the number of APs for specific firmware versions across different models.';
export const ClientModelGraphHDTT =
	'Displays the distribution of connected clients by device model, based on OS, vendor and device type';
export const SwitchModelFirmwareDistGraphHDTT =
	'Shows the distribution of switches by model and firmware version, with each bar indicating the number of switches for specific firmware versions across different models.';
export const TopApWithMaxDataUsageGraphHDTT =
	'Shows the sites with the highest Wi-Fi data usage in the most recent 5-min interval';
export const TopApWithLeastDataUsageGraphHDTT =
	'Shows the sites with the lowest Wi-Fi data usage in the most recent 5-min interval';
export const TopApWithMaxCriticalAlarmGraphHDTT =
	'Highlights the sites which reported the highest number of critical alarms.';
export const TopApWithLeastCriticalAlarmGraphHDTT =
	'Shows the sites with the lowest Wi-Fi data usage in the most recent 5-min interval';
export const VendorModelsGraphHDTT =
	'Shows the distribution of access points grouped by their respective AP Models.';
export const ApSSIDLoadGraphHDTT =
	'Indicates the load distribution across various SSIDs, in terms of connected clients.';
export const ApSSIDDataUsageGraphHDTT =
	'Indicates the load distribution across various SSIDs, in terms of connected clients.';
export const ApUptimeGraphHDTT =
	'Visualizes the uptime status of access points, grouped by time intervals';
export const ClientWirelessRadiosTT =
	'It shows which Wi-Fi protocol distribution are the most popular';
// Graph Tooltip - AP Group dashboard

export const GHz24RadioPerformanceGraphAGDTT =
	`Displays site-level aggregated performance for 2.4 GHz:
	• RSSI: Average RSSI across all APs in the site.
	• Data Rate: Average Data rate across all APs in the site.
	• PHY rate: Peak bit-rate rate across all APs in the site.
	• MCS: Most frequently used MCS value for Uplink & Downlink packet transmissions.`;
export const GHz5RadioPerformanceGraphAGDTT =
	`Displays site-level aggregated performance for 5 GHz:
	• RSSI: Average RSSI across all APs in the site.
	• Data Rate: Average Data rate across all APs in the site.
	• PHY rate: Peak bit-rate rate across all APs in the site.
	• MCS: Most frequently used MCS value for Uplink & Downlink packet transmissions.`;
export const ClientsGraphAGDTT =
	'Displays the number of clients connected to the network over time, split across the 2.4 GHz and 5 GHz frequency bands.';
export const DataBandwidthRangeGraphAGDTT =
	'Shows the distribution of clients across different bandwidth ranges, categorized by Mbps, indicating how many clients fall into each bandwidth range.';
export const IssuesGraphAGDTT =
	'Displays the distribution of issues experienced by clients over the selected time interval (e.g. 4 hours)';
export const TopPerformingAPGraphAGDTT =
	'Shows the top performing APs, in terms of Quality of Experience (QoE).';
export const TopImpactedAPGraphAGDTT =
	'Shows the worst performing APs, in terms of Quality of Experience (QoE).';
export const ActiveQOEGraphAGDTT =
	'Displays end-user quality of experience across all connected clients (when no clients are connected, QoE will not be shown)';
export const APModelFirmwareDistributionGraphAGDTT =
	'Shows the distribution of Access Points (APs) by model and the firmware version they are running. Each bar represents the count of APs for each firmware version across different models.';
export const ClientModelGraphAGDTT =
	'Displays the distribution of connected clients, based on OS, vendor and device type';
export const ApplicationUsageGraphAGDTT =
	'Shows the total data usage across applications over the selected time interval (e.g. 4 hours)';
export const SSIDLoadGraphAGDTT =
	'Displays the distribution of clients across different SSIDs, indicating the load on each SSID';
export const MapOverviewGraphAGDTT =
	'Provides a geographic visualization of the Access Points (APs) within the area, showing their physical locations on a map.';
export const ClientDisconnectTimeTT =
	"Client Disconnect Time can't be less than 5 minutes and more than 60 minutes";
export const SiteApMaxDataUsageTT = 'Shows top 5 APs in terms of  data usage over the selected time period';
export const SiteApMinDataUsageTT = 'Shows bottom 5 APs in terms of  data usage over the selected time period';
export const SiteApMaxClientsTT = 'Shows top 5 APs in terms of  client count for the selected time period';
export const SiteApMinClientsTT = 'Shows bottom 5 APs in terms of  client count for the selected time period';

// Graph Tooltip - AP dashboard

export const GHz24ChannelPerformanceGraphAPTT =
	`Displays aggregated performance for 2.4 GHz:
• RSSI: Average RSSI across all APs in the site.
• Data Rate: Average Data rate across all APs in the site.
• PHY rate: Peak bit-rate rate across all APs in the site.
• MCS: Most frequently used MCS value for Uplink & Downlink packet transmissions.`;
export const GHz5ChannelPerformanceGraphAPTT =
	`Displays aggregated performance for 5 GHz:
• RSSI: Average RSSI across all APs in the site.
• Data Rate: Average Data rate across all APs in the site.
• PHY rate: Peak bit-rate rate across all APs in the site.
• MCS: Most frequently used MCS value for Uplink & Downlink packet transmissions.`;
export const DataBandwidthRangeGraphAPTT =
	'Shows client distribution across different bandwidth ranges';
export const SessionDurationsGraphAPTT =
	'Displays the distribution of session durations across all successful client connections over the selected time interval (e.g. 4 hours)';
export const ClientSessionDurationsGraphAPTT =
	'Displays how long the client remained connected across sessions';
export const LatchingTimeGraphAPTT =
	'Displays the distribution of client connection setup time across all successful client sessions over the selected time interval (e.g. 4 hours)';
export const ClientLatchingTimeGraphAPTT =
	'Displays time taken by the client to establish a connection across all sessions';
export const IssuesGraphAPTT = 'Displays the distribution of issues experienced by clients over the selected time interval (e.g. 4 hours)';
export const ApplicationUsageGraphAPTT =
	'Shows the total data usage across applications over the selected time interval (e.g. 4 hours)';
export const ClientModelGraphAPTT =
	'Displays the distribution of connected clients by device model, based on OS, vendor and device type.';
export const CPUMemoryUtilizationGraphAPTT =
	'Tracks CPU and memory usage over time.';
export const ConnectivityGraphAPTT =
	'Displays the connection status and AP details';
export const DataRateGraphAPTT =
	'Shows the download and upload data rates over time.';
export const SignalStrengthGraphAPTT =
	'Received signal strength (RSSI) over time';
export const ActiveQOEGraphAPTT =
	'Displays end-user quality of experience across all connected clients (when no clients are connected, QoE will not be shown).';
export const SwitchModelDistributionGraphAPTT =
	'Displays the count of switches by model and firmware version within the site.';
export const TrafficPerformanceGraphAPTT =
	'Downlink and uplink data rates over time for the switches in the site.';
export const MapVisualizationGraphAPTT =
	'The locations of switches within the site on a map';
export const ChannelUtilization24 =
	'Current Channel Utilization 2.4 GHz: Data refreshes within 5 minutes';
export const ChannelUtilization5 =
	'Current Channel Utilization 5 GHz: Data refreshes within 5 minutes';
export const ChannelUtilizationGraph24 =
	'Channel Utilization 2.4 GHz: Data refreshes within 5 minutes';
export const ChannelUtilizationGraph5 =
	'Channel Utilization 5 GHz: Data refreshes within 5 minutes';
export const ChannelRankGraph24 =
	'Channel Rank Information 2.4 GHz: Data refreshes within 5 minutes';
export const ChannelRankGraph5 =
	'Channel Rank Information 5 GHz: Data refreshes within 5 minutes';
export const UplinkRateGraphTT = 'Shows the average uplink data transfer rate per radio band (2.4GHz, 5GHz).';
export const DownlinkRateGraphTT = 'Shows the average downlink data transfer rate per radio band (2.4GHz, 5GHz).';
// Graph Tooltip - Client dashboard

export const ConnectivityGraphCDTT =
	'Displays the connection status and AP details';
export const DataRateGraphCDTT =
	"Shows the link rate for the client's connection";
export const SignalStrengthGraphCDTT =
	"Shows the link RSSI for the client's connection";
export const ApplicationUsageGraphCDTT = 'Shows the total data usage across applications over the selected time interval (e.g. 4 hours)';
export const ActiveQOEGraphCDTT =
	'Displays Quality of Experience (QoE) and data usage metrics over time';
export const ClientSessionSummaryCDTT =
	"Total client sessions during the selected time period.";
export const ClientConnectionFailureSummaryCDTT =
	"Times the client failed to connect during the selected time period.";

// Tooltips for configure AP modal

export const AllowSpecificCBTT =
	'Enable this option to customize radio settings for this specific Access Point.';
export const EnableNATCBTT =
	'Enable Network Address Translation (NAT) settings for the device.';
export const NATIPTextTT = 'Enter the IP address used for NAT.';
export const NetmaskIPTextTT = 'Enter the subnet mask for the NAT IP.';
export const StartIPTextTT = 'Enter the starting IP address range for NAT.';
export const EndIPTextTT = 'Enter the ending IP address range for NAT.';
export const LeaseTimeDropdownTT =
	'Specify the lease duration for IP addresses assigned by NAT';
export const EnableVLANCBTT =
	'Enable Virtual Local Area Network (VLAN) settings for the device';
export const VLANIDNumberTT = 'Enter the VLAN ID for this configuration';
export const DHCPClientCBTT =
	'Enable DHCP to automatically obtain an IP address';
export const IP4AddressTextTT = 'Enter a unique static IP address';
export const SubnetMaskTextTT = 'Enter the subnet mask for the IP address';
export const GatewayIP4TextTT = 'Enter the gateway IP address for the network';
export const PrimaryDNS4TextTT = 'Enter the primary DNS server IP address';
export const SecondaryDNS4TextTT =
	'Enter the secondary DNS server IP address (optional)';
export const DHCPv6ClientCBTT =
	'Enable DHCPv6 to automatically obtain an IPv6 address.';
export const IPAddress6TextTT = 'Enter the static IPv6 address for the device';
export const PrefixLengthNumTT = 'Enter the prefix length for the IPv6 address';
export const GatewayIP6TextTT =
	'Enter the gateway IPv6 address for the network';
export const PrimaryDNS6TextTT = 'Enter the primary DNS server IPv6 address';
export const SecondaryDNS6TextTT =
	'Enter the secondary DNS server IPv6 address (optional)';
export const IPSecCBTT = 'Enable IPSec for secure IP communication';
export const RogueAP24GHzCBTT =
	'Enable detection of rogue Access Points on the 2.4 GHz band.';
export const RogueAP5GHzCBTT =
	'Enable detection of rogue Access Points on the 5 GHz band';
export const AutoRF24GHzCBTT =
	'Enable automatic radio frequency optimization for the 2.4 GHz band.';
export const AutoRF5GHzCBTT =
	'Enable automatic radio frequency optimization for the 5 GHz band';

// Tooltips for configure Site modal

export const NTPCBTT =
	'Syncs AP clocks with the specified NTP server';
export const NTPServer1TextTT = 'Enter the primary NTP server address.';
export const NTPServer2TextTT =
	'Enter the secondary NTP server address (optional).';
export const LLDPCBTT =
	'Enable Link Layer Discovery Protocol for network device and topology discovery.';
export const LinkAggregationCBTT =
	'Enable Link Aggregation by combining multiple physical WAN interfaces to form a single logical interface.';
export const EoGRECBTT =
	'Enable EoGRE (Ethernet Over GRE) for tunneling Ethernet traffic.';
export const EoGREProfilesDropdownTT = 'Select the EoGRE profile to be used.';
export const SecureShellCBTT =
	'Enables secure remote CLI access to APs using SSH';
export const PortNumberTT = 'Enter the port number for SSH access.';
export const CaptivePortalCBTT =
	'Enable Captive Portal for network access control.';
export const CaptivePortalProfileTT =
	'Select the Captive Portal profile to be applied.';
export const OpenFlowCBTT =
	'Enable OpenFlow support for SDN (Software-Defined Networking) configuration.';
export const OpenFlowDropdownTT = 'Select the OpenFlow controller to be used.';
export const SyslogCBTT = 'Enables logging of network events to an external Syslog server.';
export const ServiceLogServerTT =
	'Enter the IP address or hostname of the Syslog server.';
export const ServiceLogPortTT = 'Enter the port number for the Syslog server.';
export const ServiceLogProtoDropdownTT =
	'Select the protocol used for Syslog communication.';

export const WiFiSteeringCBTT =
	'Enable client steering to optimize network performance by steering clients to the optimal frequency band.';
export const AutoChannelCBTT =
	'Automatically select the best channel for the radio based on current network conditions.';
export const AssocSteeringCBTT =
	'Enable association management considering client RSSI and AP load.';
export const RequiredSNRTextTT =
	'Set the minimum Signal-to-Noise Ratio (SNR) required for a client to connect to the AP.';
export const RequiredProbeSNRTextTT =
	'Set the minimum SNR required for a client probe response.';
export const RequiredRoamSNRTextTT =
	'Set the minimum SNR at which a client should be steered to another AP.';
export const LoadKickThresholdTextTT =
	'Set the client load threshold at which the AP will steer clients to another AP.';

export const MeshCBTT =
	'Enable mesh networking to allow APs to connect wirelessly with each other.';
export const MeshNameTextTT = 'Enter the name of the mesh network.';
export const ZeroTouchMeshCBTT =
	'Enable zero-touch configuration for mesh networking.';
export const WirelessDistributionSystemCBTT =
	'Enable WDS to allow wireless distribution of data between APs.';
export const WDSNameTextTT = 'Enter the name of the WDS network.';
export const ZeroTouchWDSCBTT = 'Enable zero-touch configuration for WDS.';

export const WIDSWIPSCBTT =
	'Enable Wireless Intrusion Detection and Prevention Systems (WIDS/WIPS) to protect the network from various threats.';
export const CPUThresholdDropdownTT =
	'Set the CPU usage threshold for generating alarms.';
export const MemoryThresholdDropdownTT =
	'Set the memory usage threshold for generating alerts.';

export const ACSSchedulerDropdownTT =
	'Setup a schedule for running Automatic Channel Selection (ACS) algorithm to find the best channel.';
export const SelectProfileTypeDropdownTT =
	'Choose the ACS schedule that best suits the RF environment. Avoid frequent channel changes as they are service impacting.';

export const APCLIUsersTableTT =
	'Lists CLI users for APs with their credentials and access levels';
export const THICKGUICBTT = 'Allows AP management via local web interface';
export const BroadcastApName = 'If the user-assigned AP Name is greater than 24 characters, the beacon will include only the first 24 characters of the name.';
export const StatisticsTT = 'Device Statistics will be sent if enabled.';
export const StatsIntervalTT = 'Stats Interval should be between 60 and 3600 seconds';
export const HealthTT = 'Health Statistics will be sent if enabled.';
export const HealthIntervalTT = 'Health Interval should be between 60 and 3600 seconds';
export const SyslogTT = 'Enable to put syslog configurations.';
export const ServiceServerTT = 'External syslog server either can accept IP or hostname.';
export const ServicePortTT = 'Enter the service log port.';
export const ServiceProtocolTT = 'Select the protocol used for Syslog communication (UDP/TCP).';
export const EogreTT = 'EoGRE will run on device if enabled.';
export const EogreProfileTT = 'Select EoGRE Profile.';
export const WifiSteeringTT = 'Enable wifi steering for automatic switch to the best available freq. band.';
export const ReqSnrTT = 'Minimum signal in dBm a client will be permitted to remain connected.';
export const ReqProbeSnrTT = ' Minimum signal in dBm for management probes to be replied to.';
export const ReqRoamSnrTT = ' Minimum signal in dBm client roaming threshold.';
export const LoadKickTT = 'Minimum channel load as % available before clients are kicked.';
export const MeshWdsTT = 'Enable Mesh/WDS to set Mesh/WDS name.';
export const MeshNameTT = 'Please enter a valid Mesh name. Mesh name should be minimum 2 characters and maximum 32 characters long.';
export const WdsNameTT = 'Please enter a valid WDS name. WDS name should be minimum 2 characters and maximum 32 characters long.';
export const CaptivePortalTipTT = 'Enable Captive Portal to set Captive Portal Profile Name.';
export const CaptiveProfileTipTT = 'Select Captive Portal Profile Name.';
export const VlanRangeTT = 'Vlan ID must be in range 2-4094.';
export const CoaPortTT = 'This port is used for sending/receiving CoA messages to/from AAA server.';
// Username:
// The username assigned to the CLI user.
// Password:
// The hashed or encrypted password for the CLI user.
// User Mode:
// The access level or mode (e.g., read/write) assigned to the user.
// Created at:
// The timestamp indicating when the CLI user account was created."
// AP: Configure Group	ThickGui	Thick Gui	Checkbox	If checked, AP can be managed from the local GUI.

// tooltips for add group modal
export const RootGroupCBTT =
	'Mark this as a top-level site in the hierarchy.';
export const TIPGroupCBTT =
	'Select if site belongs to OpenWiFi (TIP)';
export const GroupNameTT = 'Enter the name of the site.';
export const EoipGroupCBTT =
	'Select to use EoIP tunnel, to add any AP to this site tunnel ID would be mandatory.';
export const LocationTT =
	"Enter the name for this site's location (e.g., city, floor, or region).";
export const RegulatoryDomainCountryTT =
	'Select the regulatory domain or country for this site.';
export const SAPIDTT = 'Enter a unique numerical identifier for this site';
export const DescriptionTT = 'Provide a brief description of the site.';
export const ParentSiteTT = 'Select the parent site to which this site belongs';
export const AnalyticsAgentTT = 'Select this to turn on the analytics agent on all the Wi-Fi 6 APs in this site';

// site radio setting

export const SITE_RADIO_SETTING_REGULATORY_DOMAIN =
	'Indicates the country code determining the regulatory domain and allowed channels.';
export const SITE_RADIO_SETTING_CHANNEL_SELECTION =
	'Select Auto to let the AP choose the best channel, or Manual to set a specific channel.';
export const SITE_RADIO_SETTING_CHANNEL =
	'Select the specific channel. Availability of channels depends on the regulatory domain.';
export const SITE_RADIO_SETTING_BANDWIDTH =
	'Choose the channel width for 5 GHz. Wider channels offer higher speeds but fewer non-overlapping options.';
export const SITE_RADIO_SETTING_BANDWIDTH_2GHZ =
	'Choose the channel width for 2.4 GHz. Wider channels offer higher speeds but fewer non-overlapping options.';
export const SITE_RADIO_SETTING_INCLUDE_DFS_CHANNEL =
	'Include Dynamic Frequency Selection (DFS) channels for additional channel options.';
export const SITE_RADIO_SETTING_EXCLUDE_NON_PSC_CHANNELS =
	'non-PSC channels part of 40/80/160/320 set as secondary channel';	
export const SITE_RADIO_SETTING_EIRP =
	'EIRP (Effective Isotropic Radiated Power) represents the total output power of the radio, adjusting the antenna gain and losses.';
export const SITE_RADIO_SETTING_ANTENNA_GAIN_ENTER =
	'Enter the Antenna gain in dBi';
export const SITE_RADIO_SETTING_ANTENNA_GAIN = 'Antenna gain in dBi';
export const SITE_RADIO_SETTING_RTS_THRESHOLD =
	'Specify the packet size above which RTS/CTS mechanism is triggered to reduce collisions in congested environments.';
export const SITE_RADIO_SETTING_CTS =
	'Enable Clear-to-Send (CTS) protection to mitigate collisions in high-interference or hidden-node environments.';
export const SITE_RADIO_SETTING_BEACON_INTERVAL =
	'Set how frequently the AP sends beacon frames.';
export const SITE_RADIO_SETTING_PROTOCOL =
	'Select the wireless protocol to be used (e.g., 802.11ax, 802.11ac).';
export const SITE_RADIO_SETTING_DL_OFDMA =
	'Enable Downlink OFDMA to transmit data to multiple clients simultaneously by dividing the channel into smaller sub-channels.';
export const SITE_RADIO_SETTING_UL_OFDMA =
	'Enable Uplink OFDMA to allow multiple clients to send data at the same time using sub-channel allocation.';
export const SITE_RADIO_SETTING_DL_MU_MIMO =
	'Enable Downlink Multi-User MIMO to support simultaneous transmissions to multiple clients using spatial streams.';
export const SITE_RADIO_SETTING_UL_MU_MIMO =
	'Enable Uplink Multi-User MIMO to support simultaneous transmissions from multiple clients using spatial streams.';
export const SITE_RADIO_SETTING_BSS_COLORING =
	'Enable BSS Coloring to distinguish between overlapping BSSs and improve spatial reuse in dense environments.';
export const SITE_RADIO_SETTING_TWT =
	'Enable Target Wake Time(TWT) to allow clients to wake up at scheduled intervals to optimize power efficiency';
export const SITE_RADIO_SETTING_MAXIMUM_CLIENT_ALLOWED =
	'Set the maximum number of client connections allowed';
export const SITE_RADIO_SETTING_MAXIMUM_CLIENT_THRESHOLD =
	'Set the maximum number of client connections allowed before load balancing is triggered.';
export const SITE_RADIO_SETTING_MAXIMUM_CHANNEL_UTILIZATION =
	'Enable to define a channel utilization threshold at which load balancing will be activated.';
export const SITE_RADIO_SETTING_CHANNEL_UTILIZATION_THRESHOLD =
	'Specify the channel utilization percentage that triggers load balancing for connected clients.';
export const SITE_RADIO_SETTING_MINIMUM_RSSI_THRESHOLD =
	'Enable to define a minimum RSSI threshold (in dBm) to steer clients toward stronger signals';
export const SITE_RADIO_SETTING_ACS =
	'Select the ACS Scheduler Profile to automate channel selection based on network conditions.';
export const SITE_RADIO_SETTING_ENABLE_AUTO_TCP =
	'Enable Automatic Transmit Power Control (ATPC) to automatically adjust the transmit power based on network conditions.';
export const SITE_RADIO_SETTING_LOW_CLIENT_THRESHOLD =
	'Set the lower threshold percentage for client count to adjust transmit power downwards.';
export const SITE_RADIO_SETTING_UPPER_CLIEND_THRESHOLD =
	'Set the upper threshold percentage for client count to adjust transmit power upwards.';
export const SITE_RADIO_SETTING_RSSI_THRESHOLD =
	'Set the RSSI (Received Signal Strength Indicator) threshold to control power adjustment.';
export const SITE_RADIO_SETTING_DEFAULT_TRANSMIT_POWER =
	'Set the default transmit power level for indoor or outdoor environments.';
export const SITE_RADIO_SETTING_MIN_TRANSMIT_POWER =
	'Enter the minimum transmit power level in dBm.';
export const SITE_RADIO_SETTING_MAX_TRANSMIT_POWER =
	'Enter the maximum transmit power level in dBm.';
export const SITE_RADIO_SETTING_CLIENT_ISOLATION =
	'Enable Client Isolation to prevent communication between clients connected to the same SSID.';
export const SITE_RADIO_SETTING_WIDS_WIPS =
	'Enable Wireless Intrusion Prevention/Detection System';
export const SITE_RADIO_SETTING_ATTACH_WIDS_WIPS_POLICY =
	'Select the WIPS/WIDS policy profile to apply to this network.';
export const ATPC_SETTING_CELL_BOUNDARY = 'Expected signal level at the cell edge: ___ dBm';
export const ATPC_SETTING_UNDERSERVED_CLIENTS = 'Increase Tx power (in 1dBm steps) until no more than ___% of clients report RSSI below the target.';
export const ATPC_SETTING_OVERSERVED_CLIENTS = 'Decrease Tx power (in 1dBm steps) until no more than ___% of clients report RSSI above the target.';
export const ATPC_INDOOR_TT = 'Define the range within which ATPC will adjust the EIRP for indoor Access Points within this site. Note that the "Min" value will be used as the default EIRP';
export const ATPC_OUTDOOR_TT = 'Define the range within which ATPC will adjust the EIRP for outdoor Access Points within this site. Note that the "Min" value will be used as the default EIRP';

// access points lan-wan:

export const Ipv4ToggleTT = 'Choose how IPV4 address is assigned';
export const Ipv6ToggleTT = 'Choose how IPV6 address is assigned';
export const DhcpModeTT = 'DHCP Mode';
export const AccessModeTT = 'Configure to make it Bridge/NAT.';
export const ManagementVlanTT = "Enable to configure a VLAN for AP management.";
export const LanVlanIdTT =
	' VLAN should be in range 1-4094. Access Port: Only 1 VLAN is allowed. Trunk Port: VLAN can be provided as a range eg.1-5 or random numbers separated by comma eg. 2,10.';
export const HighAvailabilityModeTT =
	'The AP will automatically switch to the secondary WAN interface if the specified URL is not reachable on the primary link.';
export const PrimaryLinkTT = 'Choose the primary interface for WAN connectivity.';
export const URLTT = 'Specify the URL for checking WAN link reachability to Internet.';

// configure site - add cli user
export const CLIUSERNAMETT =
	'Name of the user in order to distinguish it from other users.';
export const CLIPASSWORDTT = 'Password should be min 8 and max 64 length.';
export const CLIUSERMODETT = 'Select User Mode Read Write/Read Only';

// configure ap - ipsec tooltips:
export const LocalIdTT =
	'Local Identifier for the IPsec connection (a string of alphanumeric characters with a limit of 20 characters)';
export const RemoteIdTT =
	'Remote identifier for the IPsec connection (a string of alphanumeric characters with a limit of 20 characters)';
export const LocalIpTT =
	'The local IP address for IPsec connection (Valid Ipv4)';
export const RemoteIpTT =
	'The remote IP address for IPsec connection (Valid Ipv4)';
export const PhEncryTT =
	'Encryption algorithm to be used during IKEv2 delegation';
export const PhHashTT = 'Hash algorithm to be used during IKEv2 delegation';
export const PhDhTT = 'Diffie Hillman Cipher for IKEv2 delegation';
export const LocalNwTT =
	'Local Network on the Access Point Side (ipv4/subnet mask)';
export const RemoteNwTT =
	'Remote Network on the Access Point Side (ipv4/subnet mask)';
export const KeyRetryTT =
	'No. of keying retries allowed for Phase1 authentication (Min 1)';
export const PskPasswordTT =
	'The new password must comply with the following rules:\n' +
	'At least 8 characters.\nAt least one digit.\n' +
	'At least two lowercase characters.\n' +
	'At least two uppercase characters.\n' +
	'At least one special character.\n' +
	'And must not contain forbidden characters: #"';
export const IkeTimeTT = 'IKE lifetime for IKE SA renewal';
export const TunnelTimeTT = 'Tunnel lifetime for IPsec';
export const DpdDelayTimeTT = 'Dead Peer Detection Delay Interval';
export const DpdTimeoutTimeTT = 'Dead Peer Detection Timeout';
export const DashboardTimeFilterTT = 'Applies only to dashboard widgets';
export const LedOnOff = "Applies LED setting to all APs in this site and sets the default for future additions.";

// maintenance - network health center
export const IssuesFilterTT = `Select any issue from the list to view the affected entities. Note that the 'Clients with Issues' and 'Failed Clients' tables will not be affected by certain filters such as Arp Failures, AP Reboot.`;